import script from "./Event.vue?vue&type=script&setup=true&lang=ts"
export * from "./Event.vue?vue&type=script&setup=true&lang=ts"

import "./Event.vue?vue&type=style&index=0&id=74fc8aee&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3940516335/src/bitbucket.org/island-c/cayman-fe-operator/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74fc8aee"]])

export default __exports__